<app-inv-company-info *ngIf="person.identifier && renderNewInvoicingService === false" [person]="person" [creationMode]="true"></app-inv-company-info>

<!-- Noropia ESF -->
<div class="bloqueNotFound noESF_element_to_target" *ngIf="renderNewInvoicingService === false">
	<p class="card-text" [innerHTML]="'inv.createIS.noESFnoAuthorized' | translate:{ nif: person.identifier}"></p>
	<a class="btn btn-primary" (click)="createInvoicingServiceClicked()"><i class="fa fa-pencil"></i><span class="d-none d-md-inline-block" translate>inv.createIS.noESFBtFull</span><span class="d-inline-block d-md-none" translate>inv.createIS.noESFBt</span></a>
</div>
<!--FIN  Noropia ESF -->

<!-- FIN ESF autorizadas -->

<div class="card infoEmpresaEdit" *ngIf="renderNewInvoicingService === true">
	<div class="card-body">
		<h3 translate>inv.createIS.title</h3>

		<form>

			<div class="input-group row">
				<label class="col-md-3 col-12" translate>manager.compayInfoTitl</label>
				<div class="col-md-9 col-12 text-justify">
					<div class="nombre">{{ person.tradeName }}</div>
					<div class="codigo">{{ person.identifier }}</div>
					<div class="direccion">{{ person.address }}</div>
					<div class="telefonos">{{ person.phone }}</div>
				</div>
			</div>

			<hr>

			<div class="input-group row">
				<label class="col-md-3 col-12" translate>inv.createIS.email</label>
				<div class="col-md-9 col-12">
					<input [(ngModel)]="invoicingService.email" name="email" type="text" class="col-12 col-md-7">
					<div *ngIf="errors && errors.email.length > 0" class="notaPie ml-auto">
						<span *ngFor="let error of errors.email">{{ error }}</span>
					</div>
				</div>
			</div>
			<div class="input-group row">
				<label class="col-md-3 col-12" translate>inv.createIS.conditions</label>
				<div class="col-md-9 col-12 text-justify"><div [innerHTML]="'inv.createIS.legal' | translate:{ nif: person.identifier, person:person.tradeName}"></div>
					<div>
						<label class="form-check-label">
							<input type="checkbox" (change)="isAcceptedUseConditions = !isAcceptedUseConditions" name="isAceptedUseConditions" class="form-check-input">
							<span translate>inv.createIS.legalOk</span>
						</label>
					</div>
				</div>
			</div>

			<hr>

			<div class="input-group row">
				<label class="col-md-3 col-12" translate>inv.createIS.thirdService</label>
				<div class="col-md-9 col-12 text-justify"><div [innerHTML]="'inv.createIS.legal3' | translate:{}"></div>
					<label class="form-check-label">
					<input [(ngModel)]="invoicingService.servicesToOthers" name="servicesToOthers" type="checkbox" class="form-check-input">
						  <span translate>inv.createIS.legal3Ok</span>
					</label>
				</div>
			</div>
			<div class="botonera">
				<div class="offset-md-3 offset-0 col-md-9 col-12">
					<button class="btn btn-secondary" (click)="onCancelClicked()" type="button" translate>inv.createIS.legalBtCancel</button>
					<button class="btn btn-primary" [disabled]="isDisabledSubmit()" (click)="saveInvoicingService()" type="button" translate><i class="fa fa-download" ></i> inv.createIS.legalBtSingSave</button>
					<div id="div_sign_error" class="notaPie destacado bajoBoton"></div>
				</div>
			</div>
		</form>
		<form name="firma" id="firma">
			<input hidden id="firma_xml" name="firma[xml]" [(ngModel)]="xml"  />
			<input hidden id="firma_formularioweb" name="firma[formularioweb]"  />
			<input hidden id="firma_firma_formularioweb" name="firma[firma_formularioweb]" />
			<div hidden>
				<button hidden type="submit" id="firma_submit" name="firma[submit]" translate>inv.createIS.legalBtSing</button>
			</div>
		</form>
	</div>
</div>





// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv-invoicing-service/inv-invoicing-service.component.html